/**
 * Default API base for axios: same origin as the SPA (/api) so deploys work on any host without hardcoding.
 * Override with REACT_APP_API_URL when you need a full URL (e.g. mobile testing against a LAN IP).
 */
export function getApiBaseUrl(): string {
    const fromEnv = process.env.REACT_APP_API_URL;
    if (fromEnv != null && String(fromEnv).trim() !== '') {
        return String(fromEnv).replace(/\/$/, '');
    }
    return '/api';
}

/**
 * Public URLs for building-directory images. Same-origin proxy path unless you set REACT_APP_BUILDING_DIRECTORY_BLOB_URL.
 */
export function getBuildingDirectoryAssetBaseUrl(): string {
    const fromEnv = process.env.REACT_APP_BUILDING_DIRECTORY_BLOB_URL;
    if (fromEnv != null && String(fromEnv).trim() !== '') {
        return String(fromEnv).replace(/\/$/, '');
    }
    return `${getApiBaseUrl()}/building-directory-proxy`;
}
